// GetPageMetaData returns the meta data for a category page.
export const CategoryMetaService_GetPageMetaDataLazy = () =>
  import("./service.grpc").then((m) => m.CategoryMetaService_GetPageMetaData);
CategoryMetaService_GetPageMetaDataLazy.method =
  "aysa_api.services.category_page.v1.meta.CategoryMetaService/GetPageMetaData" as const;

// GetBreadcrumbsRequest returns the breadcrumbs for a given category.
export const CategoryMetaService_GetBreadcrumbsLazy = () =>
  import("./service.grpc").then((m) => m.CategoryMetaService_GetBreadcrumbs);
CategoryMetaService_GetBreadcrumbsLazy.method =
  "aysa_api.services.category_page.v1.meta.CategoryMetaService/GetBreadcrumbs" as const;
